module.exports = __webpack_public_path__ + "static/media/Forestry-BG-3rd-Layer-Three.e9559ac9.png";